import { loadQuery } from 'react-relay';

import RelayEnvironment from 'lib/utils/relay';
import { getUserId } from 'lib/utils/authentication';

import { userProfileQuery } from 'services/user/__generated__/userProfileQuery.graphql';
import { USER_PROFILE_QUERY } from 'services/user/user.relay.services';
import { profileProfileQuestionsQuery } from 'services/profile/__generated__/profileProfileQuestionsQuery.graphql';
import { GET_PROFILE_QUESTIONS_QUERY } from 'services/profile/profile.relay.services';

export const ProfileSetupPreloadData = () => {
  const userId = getUserId();

  /**
   * Return
   */
  return {
    userProfileRef: loadQuery<userProfileQuery>(RelayEnvironment, USER_PROFILE_QUERY, {
      id: userId,
      skip: !userId,
    }),
    profileQuestionsRef: loadQuery<profileProfileQuestionsQuery>(RelayEnvironment, GET_PROFILE_QUESTIONS_QUERY, {}),
  };
};

export type ProfileSetupPreloadDataType = ReturnType<typeof ProfileSetupPreloadData>;
